import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ListItemIcon as MuiListItemIcon, } from '@mui/material';
import { styled } from '../../utils';
import { Icon } from '../Icon';
export function ListItemIcon(props) {
    const { children, icon, ...otherProps } = props;
    return (_jsxs(ListItemIconStyled, { ...otherProps, children: [children, icon && _jsx(Icon, { variant: icon, fontSize: "inherit" })] }));
}
const ListItemIconStyled = styled(MuiListItemIcon)(({ theme }) => ({
    color: theme.palette.primary.dark,
    minWidth: 0,
    marginRight: theme.spacing(1),
}));
